


































































import Enumerable from "linq";
import { DialogMixin, ModelEditableMixin } from "../../../../../../../base/components/system/mixins";
import { Component, Mixins } from "vue-property-decorator";
import { FormatStructureEditableMixin } from "../../../mixins";
import { ExpressionOperatorKinds, IDateComparisonExpressionContent } from "../../../../../../../documaker/domain/format/objects";
import { NumberInput } from "../../../../../../../base/components/system";
import { DateComparisonExpressionSelector } from "../selectors";

@Component({
  components: {
    DateComparisonExpressionSelector,
    NumberInput,
  },
})
export default class DateComparisonExpressionEditDialog extends Mixins(DialogMixin, ModelEditableMixin, FormatStructureEditableMixin) {
  settableItems: IDateComparisonExpressionContent[] = [];
  settingDateComparisonItems: IDateComparisonExpressionContent[] = [];
  selectedSettableItems: IDateComparisonExpressionContent[] = [];
  selectedSettingItems: IDateComparisonExpressionContent[] = [];

  confirmSelected: boolean = false;

  get hasSelectedSettableItems(): boolean {
    return (this.selectedSettableItems.length > 0);
  }
  
  get hasSelectedSettingItems(): boolean {
    return (this.selectedSettingItems.length > 0);
  }

  get isTopSelectedItem(): boolean {
    return this.hasSelectedSettingItems && this.selectedSettingItems.some(v => v === this.settingDateComparisonItems[0]);
  }

  get isBottomSelectedItem(): boolean {
    return this.hasSelectedSettingItems && this.selectedSettingItems.some(v => v === this.settingDateComparisonItems[this.settingDateComparisonItems.length - 1]);
  }

  get previewText(): string {
    let text = "";
    let index = 0;
    Enumerable.from(this.settingDateComparisonItems).forEach(s => {
      index += 1;
      text += s.name;
      if (index !== this.settingDateComparisonItems.length) {
        text += this.getOperatorText(s.operator);
      }
    });
    return text;
  }

  set previewText(text: string) {
  }

  settableItemSelectionChange(value: IDateComparisonExpressionContent[]) {
    this.selectedSettableItems = value;
  }

  settingItemsSelectionChange(value: IDateComparisonExpressionContent[]) {
    this.selectedSettingItems = value;
  }

  async show(settableItems: IDateComparisonExpressionContent[], settingItems: IDateComparisonExpressionContent[]): Promise<IDateComparisonExpressionContent[]> {
    return this.showModal(async () => {
      this.settableItems = settableItems;
      this.settingDateComparisonItems = settingItems;
      this.confirmSelected = false;
      await this.waitHidden();
      return this.confirmSelected ? this.settingDateComparisonItems : null;
    });
  }

  addDateComparisonExpression() {
    // 同一オブジェクトを追加することもあるのでインスタンス作り直す
    this.settingDateComparisonItems = this.settingDateComparisonItems.concat(
      Enumerable.from(this.selectedSettableItems).select(s => ({
        reference: {
            type: s.reference.type,
            id: s.reference.id,
            key: s.reference.key,
            isDate: s.reference.isDate,
        },
        operator: s.operator,
        name: s.name,
      })).toArray());
  }

  moveItems(offset: number) {
    const indexes = this.selectedSettingItems.map(v => this.settingDateComparisonItems.indexOf(v)).sort((a, b) => a - b);
    if (offset > 0) {
      indexes.reverse();
    }
    indexes.forEach(i => this.moveItem(i, offset));
  }

  private moveItem(index: number, offset: number) {
    const item = this.settingDateComparisonItems[index];
    this.settingDateComparisonItems.splice(index, 1);
    this.settingDateComparisonItems.splice(index + offset, 0, item);
  }

  removeItems() {
    this.settingDateComparisonItems = this.settingDateComparisonItems.filter((v) => !this.selectedSettingItems.some(s => s === v));
  }

  confirmSelect(): void {
    this.confirmSelected = true;
    this.isVisible = false;
  }

  cancelSelect(): void {
    this.isVisible = false;
  }

  private getOperatorText(operator: ExpressionOperatorKinds) {
    switch (operator) {
      case ExpressionOperatorKinds.LessThan: return " > ";
      case ExpressionOperatorKinds.LessThanOrEqualTo: return " >= ";
      case ExpressionOperatorKinds.GreaterThan: return " < ";
      case ExpressionOperatorKinds.GreaterThanOrEqualTo: return " <= ";
      case ExpressionOperatorKinds.Euqal: return " == ";
      case ExpressionOperatorKinds.NotEqual: return " != ";
    }
  }
}
